import { Skeleton } from '@wwe-portal/ui/components/skeleton';

export function SubscriptionCarouselSkeleton() {
  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-center gap-4">
        <Skeleton className="h-[482px] w-full md:w-[316px]" />
        <Skeleton className="hidden h-[482px] w-full md:block md:w-[316px]" />
      </div>
    </div>
  );
}
